<template>
  <div>
      <list
      row-key="ContentId"
      ref="list"
      unit="内容"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      :delete-func="api.delete"
      :default-sort="{prop: 'PublishTime', order: 'descending'}"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
         <el-form-item label="所属栏目">
           <select-input 
                width="178px"
                placeholder="选择栏目"
                :label="ColumnName"
                v-model="params.IdChain"
                @click="openColumnDialog"
              />  
        </el-form-item>
        <el-form-item label="标题">
          <el-input
            size="mini"
            v-model="params.Title"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="前台显示">
          <el-select v-model="params.IsShow" clearable size="mini">
            <el-option :value="true" label="是"></el-option>
            <el-option :value="false" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="热点">
          <el-select v-model="params.IsRecommend" clearable size="mini">
            <el-option :value="true" label="是"></el-option>
            <el-option :value="false" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="置顶">
          <el-select v-model="params.IsTop" clearable size="mini">
            <el-option :value="true" label="是"></el-option>
            <el-option :value="false" label="否"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ColumnName" label="所属栏目" width="180" sortable />
        <el-table-column prop="Title" label="标题" min-width="200" />
        <el-table-column prop="ExternalLink" label="外部链接" width="160" show-overflow-tooltip />
        <el-table-column
          prop="IsShow"
          align="center"
          label="前台显示"
          width="80"
        >
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success" v-if="row.IsShow">是</el-tag>
            <el-tag size="mini" type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="IsRecommend" align="center" label="热门" width="80">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success" v-if="row.IsRecommend">是</el-tag>
            <el-tag size="mini" type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="IsTop" align="center" label="置顶" width="80" sortable>
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success" v-if="row.IsTop">是</el-tag>
            <el-tag size="mini" type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Publisher" align="center" label="发布人" width="100"/>
        <el-table-column prop="PublishTime" align="center" label="发布时间" sortable>
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.PublishTime)}}</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <column-dialog
      ref="columnDialog"
      title="选择所属栏目"
      @select="setColumnId"
      :isAll="true"
    ></column-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import columnDialog from "@/components/website/column/listDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    columnDialog
  },
  data() {
    return {
      api: require("@/api/website/content/content").default,
      params: {
        IdChain:"",
        Title: "",
        IsShow: null,
        IsRecommend: null,
        IsTop: null,
      },
      ColumnName:"",
      sourceData: null,
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    openColumnDialog() {
      this.$refs.columnDialog.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    setColumnId(parent) {
      this.params.IdChain = parent.IdChain;
      this.ColumnName = parent.ColumnName;
    },
  }
};
</script>